import { PackageStatusEnum } from "../../__generated__/graphql";
import type { PackageStatusFilter } from "./types";

export const PACKAGE_PAGE_SIZE = 5;

export const STATUS_FILTER_OPTIONS: { label: string; value: PackageStatusFilter }[] = [
  { label: "All", value: "ALL" },
  { label: "Active", value: PackageStatusEnum.Active },
  { label: "Inactive", value: PackageStatusEnum.Terminated },
];

export function toStatusFilter(value: string | null): PackageStatusFilter {
  return STATUS_FILTER_OPTIONS.find((option) => option.value === value)?.value ?? "ALL";
}
